import { render, staticRenderFns } from "./news_content.vue?vue&type=template&id=981cd522&scoped=true&"
import script from "./news_content.vue?vue&type=script&lang=js&"
export * from "./news_content.vue?vue&type=script&lang=js&"
import style0 from "./news_content.vue?vue&type=style&index=0&id=981cd522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981cd522",
  null
  
)

export default component.exports